import type { HTMLAttributes, ReactNode } from 'react'

import { cn } from '@/lib/cn'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Карточка, на которую наводят и жмут: приподнимается под курсором. */
  interactive?: boolean
}

/// Карточка: подложка и мягкая тень вместо обводки.
///
/// Рамку убрали намеренно — сетка из полутора десятков окантованных блоков
/// читалась как таблица форм. Высоту над холстом теперь задаёт тень, а тон
/// `surface` отличается от `canvas` достаточно, чтобы край был виден и без неё.
export function Card({ className, interactive = false, ...rest }: CardProps) {
  return (
    <div
      className={cn(
        'rounded-card bg-surface shadow-card',
        interactive &&
          'cursor-pointer transition duration-200 ease-out-soft hover:-translate-y-0.5 hover:shadow-card-hover',
        className,
      )}
      {...rest}
    />
  )
}

export function CardHeader({
  title,
  subtitle,
  actions,
  className,
}: {
  title: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
  className?: string
}) {
  return (
    <div className={cn('flex flex-wrap items-start justify-between gap-3 px-5 pt-5 pb-3', className)}>
      <div className="min-w-0">
        <h2 className="text-base font-bold text-ink">{title}</h2>
        {subtitle ? <p className="mt-0.5 text-[13px] text-ink-muted">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  )
}
